import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { FormOfPaymentIssuerSearchService } from "./form-of-payment-issuer-search.service";
import { Subscription } from "rxjs";
import { FormOfPaymentIssuerSearchCriteria, FormOfPaymentIssuerUpdateStatusCode } from "./form-of-payment-issuer-search.model";
import { FormOfPaymentIssuerSearch } from "src/app/core/models/form-of-payment-model";
import { LoadingSpinnerService } from "src/app/shared/layout/loading-spinner";
import { ACTION_STATUS, ActionBarHandlerModel, ActionbarService } from "src/app/shared/ui/actionbar";
import { NewButtonModel, SaveButtonModel, CancelButtonModel, RefreshButtonModel } from "src/app/shared/ui/actionbar/models";
import { SecurityGroupService } from "src/app/core/services/system-services/security-group.service";
import { NavigationService } from "src/app/shared/utils/navigation";
import { filter } from "rxjs/operators";
import { Router } from "@angular/router";
import { FormOfPaymentIssuerSecurityCode } from "../../payment-definition-categories";

@Component({
    selector: 'op-form-of-payment-issuer-search',
    templateUrl: './form-of-payment-issuer-search.component.html',
})
export class FormOfPaymentIssuerSearchComponent implements OnInit, OnDestroy, AfterViewInit {

    actionBarHandler = new ActionBarHandlerModel(
        new NewButtonModel(),
        new SaveButtonModel(),
        new CancelButtonModel(),
        new RefreshButtonModel(),
    )

    criteria: FormOfPaymentIssuerSearchCriteria
    results: FormOfPaymentIssuerSearch[]

    private subscriptions: Subscription[]

    constructor(private formOfPaymentIssuerSearchService: FormOfPaymentIssuerSearchService,
        private loadingSpinnerService: LoadingSpinnerService,
        private actionbarService: ActionbarService,
        private securityGroupService: SecurityGroupService,
        private navigateService: NavigationService,
        private cdr: ChangeDetectorRef,
        private router: Router) {
    }
    ngOnInit(): void {
        this.results = []
        this.subscriptions = []
        this.subscriptions.push(
            this.formOfPaymentIssuerSearchService.callSearch$
                .pipe(
                    filter(flg => !!flg)
                )
                .subscribe(() => {
                    this.subscriptions.push(
                        this.formOfPaymentIssuerSearchService.formOfPaymentIssuers$.subscribe(formOfPaymentIssuers => {
                            this.results = formOfPaymentIssuers
                        })
                    )
                    this.subscriptions.push(
                        this.formOfPaymentIssuerSearchService.loadStatusReference().subscribe()
                    )
                })
        )
        this.subscriptions.push(
            this.formOfPaymentIssuerSearchService.refresh$
                .subscribe(() => {
                    this.search(this.criteria)
                })
        )
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }
    ngAfterViewInit(): void {
        this.setupActionBar()

        this.subscriptions.push(
            this.securityGroupService.userSecurityGroupSecurity
                .subscribe(userSecurities => {
                    const security = userSecurities.find(s => s.securityCode == FormOfPaymentIssuerSecurityCode);

                    if (security) {
                        this.actionBarHandler.get(ACTION_STATUS.new).enable(security.newFlag);
                        this.actionbarService.updateState(this.actionBarHandler);
                    }
                })
        )
    }

    private setupActionBar() {
        this.actionBarHandler.get(ACTION_STATUS.new).enable(false);
        this.actionBarHandler.get(ACTION_STATUS.save).enable(false);
        this.actionBarHandler.get(ACTION_STATUS.cancel).enable(true);
        this.actionBarHandler.get(ACTION_STATUS.refresh).enable(true);
        this.actionbarService.updateState(this.actionBarHandler);
    }

    search(criteria: FormOfPaymentIssuerSearchCriteria): void {
        if (criteria)
            this.criteria = criteria

        this.loadingSpinnerService.show()
        this.subscriptions.push(
            this.formOfPaymentIssuerSearchService.getFormOfPaymentIssuersSearch(this.criteria)
                .subscribe(() => {
                    this.loadingSpinnerService.hide()
                    this.cdr.markForCheck()
                },
                    () => this.loadingSpinnerService.hide())
        )
    }

    clear(): void {
        this.formOfPaymentIssuerSearchService.clearSearch()
    }

    updateStatusCode(obj: FormOfPaymentIssuerUpdateStatusCode): void {
        this.loadingSpinnerService.showSaving()
        this.subscriptions.push(
            this.formOfPaymentIssuerSearchService.updateStatusCode(obj.formOfPaymentIssuerCode, obj.statusCode)
                .subscribe(() => {
                    this.saveCompleteAndContinue(() => {
                        this.search(this.criteria)
                    })
                },
                    () => this.loadingSpinnerService.hide())
        )
    }

    private saveCompleteAndContinue(action) {
        this.loadingSpinnerService.saveComplete()
        setTimeout(() => {
            action()
        }, 1000);
    }

    navigateDetail(params) {
        this.formOfPaymentIssuerSearchService.saveCriteria(this.router.url.split('/')[3], this.criteria)
        this.navigateService.navigate(`/main/settings/form-of-payment-issuer-detail`, null, false, params)
    }
}
